/**
 * @generated SignedSource<<1a6681eeb627cbe85094108e897ddbd4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly " $fragmentType": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment";
};
export type ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "24af67d646910e1784019b6a037f34e4";

export default node;
